import { render, staticRenderFns } from "./HealthReport.vue?vue&type=template&id=12bf1f8b&"
import script from "./HealthReport.vue?vue&type=script&lang=js&"
export * from "./HealthReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports